import slugify from "slugify"
import { CarrotPlanMediaType } from "types/CarrotPlanOptions"
import Settings from "../../../utils/CarrotConfig"

interface Fields {
  label: string
  slug?: string
  navTitle?: string
}

interface BuildLinkParams {
  fields: Fields
  categoryTitle: string
  mediaTypeId?: CarrotPlanMediaType
}

const buildSlug = (fields: Fields) => (fields.slug ? fields.slug : slugify(fields.navTitle ?? fields.label))

export const buildCategoryLink = (categoryTitle: string) => {
  return `${Settings.CARROT_FRONTEND_URL}read/${buildSlug({ label: categoryTitle })}`
}

export const buildMediaLink = ({ fields, categoryTitle, mediaTypeId }: BuildLinkParams) => {
  const categoryUrl = buildCategoryLink(categoryTitle)
  switch (mediaTypeId) {
    case CarrotPlanMediaType.Article:
    case CarrotPlanMediaType.Video:
      return `${categoryUrl}/${buildSlug(fields)}`
    case CarrotPlanMediaType.Guide:
      return `${categoryUrl}/guide/${buildSlug(fields)}`
    case CarrotPlanMediaType.Group:
      return `${categoryUrl}/group/${buildSlug(fields)}`
  }
}

export const buildSubCategoryLink = ({ fields, categoryTitle }: BuildLinkParams) => {
  const categoryUrl = buildCategoryLink(categoryTitle)
  return `${categoryUrl}#${buildSlug(fields)}`
}
